<template>
  <div class="top-bar">
    <div class="page-top">
      <div class="content-container">
        <el-row type="flex" justify="space-between" align="middle" class="page-top-row">
      <el-col :xs="8" :sm="12" :md="16" class="left-section"></el-col>
      <el-col :xs="16" :sm="12" :md="8" class="translate-right-section ignore">
        <span class="clock">{{ currentTime }}</span>
        <el-button @click="switchToChinese" :style="{ border: 'none', background: 'none', color: 'white', padding: '0' }"
          class="btn">中文</el-button>
        <div class="vertical-line"></div>

        <el-button @click="switchToEnglish" :style="{ border: 'none', background: 'none', color: 'white', padding: '0' }"
          class="btn">English</el-button>
      </el-col>
    </el-row>
      </div>
    </div>
   
    <div class="logo-container">
      <img  
        src="@/assets/logo.png" alt="Logo" class="logo">
    </div>
  </div>

</template>

<script>
import useI18n from 'vue-i18n';
import { watchEffect } from 'vue';

export default {
  data() {
    return {
      // currentTime: new Date().toLocaleString(),
      currentLanguage: '中文'
    };
  },
  computed: {
    currentTime() {
      var d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补零
      const day = String(d.getDate()).padStart(2, '0'); // 补零
      return `${year}年${month}月${day}日`;
    }
  },
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang; // 更新当前语言
      localStorage.setItem('lang', lang); // 保存到 localStorage
      localStorage.setItem('translate_lang', lang === 'en' ? 'english' : 'chinese_simplified');
    },
    switchToChinese() {
      const savedLang = localStorage.getItem('lang');
      if (savedLang === 'zh') {
        return;
        
      }
      this.currentLanguage = '中文';
      window.translate.changeLanguage('chinese_simplified');
      this.setLanguage('zh');
    },
    switchToEnglish() {
      const savedLang = localStorage.getItem('lang');
      if (savedLang === 'en') {
        return;
        
      }
      this.currentLanguage = 'English';
      window.translate.changeLanguage('english');
      this.setLanguage('en');
    }
  },
  mounted() {
    const savedLang = localStorage.getItem('lang');
    const savedTranslateLang = localStorage.getItem('translate_lang');
     
  }
};
</script>

<style>
.content-container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 300px;
  height: 100%;
  display: flex;
  align-items: center;
}
.page-top {
  background-image: linear-gradient(to right, #F7EE02 0%, #F0E935 5%, #1498CE 100%);
  background-size:  100% 100%;
  height: 36px;
  width: 100%;
  position: relative;
 
}
.page-top-row {
  height: 100%;
  width:100%;
  background: transparent;
}
.top-bar {
  height: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;
  
}

.logo-container {
  background-image: linear-gradient(to right, #D3DE49 0%, #B7D45D 100%);
  /* background-image: linear-gradient(to right, #F7EE02 0%, #F0E935 15%, #1498CE 100%); */
  height: 60px;
  width: 200px;
  position: absolute;
  top: 6px;
  left: 300px;
  
  z-index: 10;
  box-sizing: border-box;
  background-size: 100% 100%; /* 调整背景尺寸 */
  background-position: left center; /* 确保从左侧开始渐变 */
}

.logo{
  width: 80%;
  height: 80%;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.translate-right-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.clock {
  margin-right: 20px;
  color: white;

}

.btn {
  border: none;
  background: none;
  color: white;
  margin-left: 10px;
  transition: color 0.3s;
  
}

.btn:hover {
  color: skyblue !important;
}

.vertical-line {
  width: 1px;
  height: 20px;
  background-color: white;
  margin: 0 10px;
}

@media screen and (max-width: 27in) {
  .logo-container {
    background-image: linear-gradient(to right, #D3DE49 0%, #B7D45D 100%);
  }
}
@media screen and (min-width: 23in) {
  .logo-container {
    background-image: linear-gradient(to right, #D7E04A 0%, #BFD758 100%);
  }
}
@media screen and (max-width: 768px) {
  .page-top {
    height: 32px;
  }
  .content-container{
    padding: 0 ;
  }
  .logo-container {
    width: 120px;
    height: 40px;
    top: 4px;
    left: 15px; /* 移动端时调整左侧距离 */
  }

 

  .clock {
    margin-right: 8px;
    font-size: 11px;
  }

  .btn {
    font-size: 11px;
    margin-left: 4px;
    padding: 0 4px !important;
  }

  .vertical-line {
    margin: 0 4px;
    height: 16px;
  }
  .translate-right-section {
    padding-right: 15px; /* 移动端时调整右侧内边距 */
    padding-left: 5px;
    justify-content: flex-end;
     btn{
      font-size: var(--text-xs) !important;
     }
     span {
      font-size: var(--text-xs) !important;
     }
  }
}

@media screen and (max-width: 480px) {
  .page-top {
    height: 28px;
  }
  .content-container{
    padding: 0 ;
  }
  .translate-right-section {
    padding-right: 15px; /* 移动端时调整右侧内边距 */
    padding-left: 5px;
    justify-content: flex-end;
  }
  .logo-container {
    width: 100px;
    height: 36px;
    top: 2px;
    left: 15px;
    background-image: linear-gradient(to right, #F3EB21 0%, #BFD758 100%);
  }

  .clock {
    margin-right: 6px;
    font-size: 10px;
  }

  .btn {
    font-size: 10px;
    margin-left: 3px;
  }

  .vertical-line {
    margin: 0 3px;
    height: 14px;
  }
}
</style>